<template>
    <svg
        v-if="name === 'arrow-right'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M3.5 10h13M11 4.5L16.5 10 11 15.5"
            :stroke="color"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
    <svg
        v-else-if="name === 'check'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            d="M2.5 6.2 5 8.5l4.5-5"
            :stroke="color"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
    <svg
        v-else-if="name === 'caret'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M4 6l4 4 4-4"
            :stroke="color"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
    <svg
        v-else-if="name === 'close'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M5 5l10 10M15 5L5 15"
            :stroke="color"
            stroke-width="1.6"
            stroke-linecap="round"
        />
    </svg>
    <svg
        v-else-if="name === 'info'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 18 18"
        fill="none"
    >
        <circle cx="9" cy="9" r="7.4" :stroke="color" stroke-width="1.3" />
        <path d="M9 7.5v3.7" :stroke="color" stroke-width="1.3" stroke-linecap="round" />
        <circle cx="9" cy="5.5" r="0.9" :fill="color" />
    </svg>
    <svg
        v-else-if="name === 'warning'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 18 18"
        fill="none"
    >
        <circle cx="9" cy="9" r="7.4" :stroke="color" stroke-width="1.3" />
        <path d="M9 4.6v5.6" :stroke="color" stroke-width="1.3" stroke-linecap="round" />
        <circle cx="9" cy="13" r="0.9" :fill="color" />
    </svg>
    <svg
        v-else-if="name === 'download'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10 3.5v9.2M5.8 9.2L10 13.4l4.2-4.2M4 16.5h12"
            :stroke="color"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
    <svg
        v-else-if="name === 'shield-check'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M9 2.2 14.5 4.2v4.6c0 3.6-2.4 6-5.5 7-3.1-1-5.5-3.4-5.5-7V4.2L9 2.2Z"
            :stroke="color"
            stroke-width="1.3"
            stroke-linejoin="round"
        />
        <path
            d="m6.5 8.9 1.7 1.7L11.6 7"
            :stroke="color"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
    <svg
        v-else-if="name === 'phone'"
        :width="resolvedSize"
        :height="resolvedSize"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M16.5 13.6c0-.6-.3-1.1-.8-1.3l-1.7-.9c-.5-.3-1.1-.2-1.5.2l-.6.6c-1.5-.7-2.8-2-3.5-3.5l.6-.6c.4-.4.5-1 .2-1.5l-.9-1.7c-.2-.5-.7-.8-1.3-.8H5.6C4.7 4.1 4 4.8 4 5.7c0 5.7 4.6 10.3 10.3 10.3.9 0 1.6-.7 1.6-1.6v-.8z"
            :stroke="color"
            stroke-width="1.5"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
const DEFAULT_SIZES = {
    'arrow-right': 20,
    check: 12,
    caret: 16,
    close: 20,
    info: 18,
    warning: 18,
    download: 20,
    'shield-check': 18,
    phone: 20,
}

export default {
    name: 'CalcIcon',

    props: {
        name: {
            type: String,
            required: true,
            validator: (v) =>
                [
                    'arrow-right',
                    'check',
                    'caret',
                    'close',
                    'info',
                    'warning',
                    'download',
                    'shield-check',
                    'phone',
                ].includes(v),
        },
        color: {
            type: String,
            default: 'currentColor',
        },
        size: {
            type: Number,
            default: null,
        },
    },

    computed: {
        resolvedSize() {
            return this.size !== null ? this.size : DEFAULT_SIZES[this.name]
        },
    },
}
</script>
